import { useEffect, type ReactNode, type CSSProperties, type MouseEvent } from 'react'

export interface PopoverProps {
  isVisible: boolean
  children: ReactNode
  hidePopover: () => void
  position?: 'left' | 'right' | 'center'
  offsetY?: number
  minWidth?: string
}

export default function Popover({ isVisible, children, hidePopover, position, offsetY = 2, minWidth = '150px' }: PopoverProps) {

  useEffect(() => {
    if (isVisible) {
      document.addEventListener('mousedown', hidePopover)
    }

    return () => {
      document.removeEventListener('mousedown', hidePopover)
    }
  }, [isVisible, hidePopover])

  if (!isVisible) {
    return null
  }

  const stopDismiss = (e: MouseEvent) => {
    e.stopPropagation()
  }

  const style: CSSProperties = {
    position: 'absolute',
    zIndex: 1000,
    transform: `translateY(${offsetY}px)`,
    top: 0,
    minWidth: minWidth,
    fontWeight: '400'
  }
  if (position === 'right') {
    style.left = 0
  } else if (position === 'left') {
    style.right = 0
  } else {
    style.left = '50%'
    style.transform = `translate(-50%, ${offsetY}px)`
  }

  return (
    <div style={style} onMouseDown={stopDismiss}>
      {children}
    </div>
  )
}
